import { FC } from 'react';
import { ArchivedCaseListCommonContainer } from '../../../../../shared/related-cases/archived-case-list-common.container';

interface ArchivedCaseListContainerProps {
  caseId: string;
  isVerticalColumn: boolean | undefined;
  applicantId: string;
}

export const ArchivedCaseListContainer: FC<ArchivedCaseListContainerProps> = (props) => {
  return <ArchivedCaseListCommonContainer applicantId={props.applicantId} isVerticalColumn={props.isVerticalColumn} />;
};
